export const defaultOsSituationState = () => ({
  id: undefined,
  description: null,
  isDefault: false,
  active: false,
});

const defaultOSSituationsModuleState = () => ({
  summaryOsSituations: [],
  paginationOsSituations: {
    perPage: 15,
    currentPage: 1,
  },
});

const initialState = {
  ...defaultOSSituationsModuleState(),
  osSituation: {
    ...defaultOsSituationState(),
  },
  osSituationsWarnings: [],
  tableKey: 0,
};

export default {
  ...initialState,
};
